import { ChatWidgetElement } from "./chat-widget.js";
import { WIDGET_VERSION } from "./config.js";

export { ChatWidgetElement } from "./chat-widget.js";
export { WIDGET_VERSION } from "./config.js";
export type {
  WidgetTheme,
  WidgetPosition,
  WidgetLocale,
  WidgetEventMap,
  DocsInquiryContext,
  InboundMessage,
  OutboundMessage,
} from "./types.js";

const TAG = "ksides-chat";

function safeDefine(): void {
  try {
    if (typeof window === "undefined" || typeof customElements === "undefined") return;
    if (customElements.get(TAG)) return;
    customElements.define(TAG, ChatWidgetElement);
    (window as unknown as Record<string, unknown>).__ksides = {
      version: WIDGET_VERSION,
      tag: TAG,
    };
  } catch (err) {
    if (typeof console !== "undefined" && console.warn) {
      console.warn(`[ksides-chat] define failed`, err);
    }
  }
}

safeDefine();

declare global {
  interface HTMLElementTagNameMap {
    "ksides-chat": ChatWidgetElement;
  }
}
